const SYNC_EVENT_PREFIX = /^(MANUAL|REGULAR)_/;

export const formatSyncEventLabel = (event?: string | null): string => {
  const raw = event?.trim();

  if (!raw) {
    return "";
  }

  const words = raw.replace(SYNC_EVENT_PREFIX, "").replace(/_/g, " ").trim().toLowerCase();

  if (!words) {
    return "";
  }

  return words.charAt(0).toUpperCase() + words.slice(1);
};
